import { fetchV1 } from "../lib/requester/v1";


// export function populateCompetitors(keywords) {
// 	return fetchV1(`/companies?value=${keywords}`, { method: "GET" });
// }

export function populateCompetitors() {
	return fetchV1(`/companies`, { method: "GET" });
}